import { createSlice } from '@reduxjs/toolkit';

/**
 * The monthly bill, as far as this machine is concerned.
 *
 * Small on purpose. Whether money is owed is not in here — that is
 * `business.notify`, which arrives with the login reply and belongs to the
 * login slice. This holds only the three things that are about this session:
 * the plans it fetched, whether the dialog is up, and whether somebody has
 * tucked the strip away.
 *
 * It needs no clearing on logout: store.js empties every slice but `login`
 * when a session ends, so a new person on this till starts with the strip
 * showing and the plans re-fetched for their business.
 */
const initialState = {
  /** From GET /configuration. Fetched once per session. */
  plans: [],
  plansFetched: false,
  plansError: '',

  /** Whether the payment dialog is up. */
  payOpen: false,

  /**
   * The strip can be tucked away for the rest of the session — but only when
   * the business is on `loop`. It is a reminder then, and a reminder you
   * cannot silence is just noise. On `stuck` the strip has no ✕ at all and
   * this is never set.
   */
  bannerHidden: false,
};

export const billingSlice = createSlice({
  name: 'billing',
  initialState: { ...initialState },
  reducers: {
    plansLoaded: (state, action) => {
      state.plans = action.payload || [];
      state.plansFetched = true;
      state.plansError = '';
    },
    plansFailed: (state, action) => {
      state.plans = [];
      // Left false, so the next open tries again rather than showing an empty
      // plan strip forever.
      state.plansFetched = false;
      state.plansError = action.payload || '';
    },
    openPay: (state) => {
      state.payOpen = true;
    },
    closePay: (state) => {
      state.payOpen = false;
    },
    hideBanner: (state) => {
      state.bannerHidden = true;
    },
  },
});

export const { plansLoaded, plansFailed, openPay, closePay, hideBanner } =
  billingSlice.actions;

export default billingSlice.reducer;
